// extracted by mini-css-extract-plugin
export var active = "_2r-2";
export var highlight = "_2r-1";
export var highlightLayer = "_2r-0";
export var issuePopover = "_2r-3";
export var statusIcon = "_2r-4";